export default "__VITE_ASSET__CyXmY1Fm__"